(function () {
  angular
    .module('kareo.ui.shared.modules.api.provider.k-specialty-service', [])
    .factory('kSpecialtyService', kSpecialtyService);

  kSpecialtyService.$inject = ['$http'];
  function kSpecialtyService($http) {
    const svc = {};

    svc.getKareoSpecialties = getKareoSpecialties;
    svc.getProviderSpecialties = getProviderSpecialties;

    return svc;

    // ----------------------------------------------------------------------

    function getProviderSpecialties() {
      return $http
        .get('/admin-ui/api/Shared/providerSpecialties', {
          cache: true
        })
        .then((response) => {
          return response.data;
        });
    }

    function getKareoSpecialties() {
      return $http
        .get('/common-ui/api/User/kareoSpecialty', {
          cache: true
        })
        .then((response) => {
          return response.data;
        });
    }
  }
})();
